import { render, staticRenderFns } from "./KarmaLeaderboard.vue?vue&type=template&id=3c0afe2a&"
import script from "./KarmaLeaderboard.vue?vue&type=script&lang=js&"
export * from "./KarmaLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./KarmaLeaderboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports